var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp"},[_vm._l((_vm.textLineList),function(line,index){return [_c('span',{key:'s' + index,domProps:{"innerHTML":_vm._s(line)}}),(index < _vm.textLineList.length - 1)?_c('br',{key:'br' + index}):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }